import { useQuery } from '@tanstack/react-query';
import { authQueryKeys } from 'pages/auth/authQueryKeys';
import { authService } from 'pages/auth/authService';

export const useAuthQuery = () =>
  useQuery(authQueryKeys.token, () => authService.getTokenFromStorage(), {
    staleTime: Infinity,
    cacheTime: Infinity,
  });
